export const SET_LOADER = 'SET_LOADER'

export const RESET_LOADER = 'RESET_LOADER'

export const SET_LOADER_WITH_TEXT = 'SET_LOADER_WITH_TEXT'

export const SET_USUARIO = 'SET_USUARIO'

export const CLEAR_USUARIO = 'CLEAR_USUARIO'

export const SET_SENHA_STATUS = 'SET_SENHA_STATUS';
